import { css } from 'styled-components';
import { colors } from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';
import { buttonHeight, paddingSize, fontSizes } from './baseButtonStyleUtils.js';

/* eslint-disable unicorn/filename-case */
const buttonFocusStyles = `
  outline: ${colors.border.focusOutline} dashed 1px;
  outline-offset: 2px;
  -moz-outline-radius: 4px;
  text-decoration: underline;
`;
const buttonDisabledStyles = `
  cursor: not-allowed;
  color: ${colors.palette.gray.dark};
  background-color: ${colors.background.lightest};
  border-color: ${colors.border.container.default};
`;
const buttonStyles = css`
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({
  isFullWidth
}) => isFullWidth && ` width: 100%;`};
  ${({
  size = 'md'
}) => `
    height: ${buttonHeight(size)};
    padding: 0 ${paddingSize(size)};
    ${ndsFontReset({
  lineHeight: 1,
  fontSize: fontSizes(size),
  whiteSpace: 'nowrap',
  textAlign: 'center',
  verticalAlign: 'middle'
})}
  `};
  margin: 0;

  text-decoration: none;
  text-overflow: ellipsis;
  overflow: hidden;
  user-select: none;
  touch-action: manipulation;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  cursor: pointer;

  &:focus {
    ${buttonFocusStyles};
  }

  &:disabled {
    ${buttonDisabledStyles};

    &:hover {
      ${buttonDisabledStyles};
    }
  }
`;

export { buttonDisabledStyles, buttonFocusStyles, buttonStyles };
